import { Box, Button, CircularProgress, Grid } from '@mui/material';
import { Form, Formik } from 'formik';
import React, { memo, useState } from 'react';
import Textfield from '../../components/input/Textfield';
import * as Yup from 'yup';
import { apiRequest } from '../../utils/api';
import { useDispatch } from 'react-redux';
import { fetchRepsData } from '../../redux/slices/repSlice';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const EditPassword = ({ onClose, user }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const FORM_VALIDATION = Yup.object().shape({
        newPassword: Yup.string().trim().min(8, 'Password must be at least 8 characters long').required('Required')
    });

    const handleSubmit = async (values) => {
        try {
            const resp = await apiRequest('put', `users/setPassword/${user?.id}`, values);

            if (resp?.data) {
                onClose();
                toast.success('Password changed successfully');
            }
        } catch (error) {
            toast.error(error?.response?.data?.message ?? error?.response?.data ?? error?.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Formik
                initialValues={{
                    newPassword: ''
                }}
                validationSchema={FORM_VALIDATION}
                onSubmit={(values, { resetForm }) => {
                    setLoading(true);
                    handleSubmit(values, resetForm);
                }}
            >
                <Form>
                    <Grid container direction="row" spacing={2}>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Textfield name="newPassword" label="New Password" />
                        </Grid>
                    </Grid>

                    <Box sx={styles.btnContainer}>
                        {loading ? (
                            <CircularProgress size={25} color="inherit" />
                        ) : (
                            <>
                                {/* -------------- onClick will call the onClose function that closes the History Modal */}
                                <Button onClick={onClose} variant="text" sx={{ color: 'red' }}>
                                    Cancel
                                </Button>

                                {/* -----------  change button title on the basis of history status */}
                                <Button type="submit" variant="text">
                                    Update
                                </Button>
                            </>
                        )}
                    </Box>
                </Form>
            </Formik>
        </div>
    );
};

export default memo(EditPassword);

const styles = {
    loadingContainer: {
        height: 400,
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    btnContainer: {
        display: 'flex',
        direction: 'row',
        gap: 1,
        marginTop: 1,
        justifyContent: 'flex-end'
    }
};
